export type IDElement = {
  id: string;
};

export type ReferenceElement = {
  reference: string;
};

export function appendUUID<T>(element: T): T & IDElement {
  return { ...element, id: window.crypto.randomUUID() };
}

export function applyReference<T>(element: T, reference: string): T & ReferenceElement {
  return { ...element, reference };
}

export function syncReferenceArray<T extends IDElement, E extends ReferenceElement>(
  emptyNewElement: Omit<E, "reference">,
  sourceArray?: T[],
  dataArray?: E[],
): E[] {
  if (!sourceArray || !dataArray) {
    return [];
  }
  return sourceArray.map((s) => dataArray.find((d) => s.id === d.reference) ?? (applyReference(emptyNewElement, s.id) as E)) ?? [];
}
